module.exports = __webpack_public_path__ + "img/chevron-der.ef2218e1.svg";